import { useAuth } from "../../auth/context";
import config from "../../config";
import _ from "lodash";

export default module => {
  const { user } = useAuth();
  const healthCenterId = user.profile?.healthCenter?.id || user.myHealthCenter?.id;
  const rules = config.healthCentersRules;
  const healthCenterRules = _.find(rules, { healthCenterId });
  return _.get(healthCenterRules, `rules.${module}`, {});
};